export default "__VITE_ASSET__038030ab__"